module.exports = __webpack_public_path__ + "img/maps2.62f37a3a.jpg";